import { render, staticRenderFns } from "./bidResultNotification.vue?vue&type=template&id=d036a3d6&scoped=true"
import script from "./bidResultNotification.vue?vue&type=script&lang=js"
export * from "./bidResultNotification.vue?vue&type=script&lang=js"
import style0 from "./bidResultNotification.vue?vue&type=style&index=0&id=d036a3d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d036a3d6",
  null
  
)

export default component.exports